import React, { useState } from 'react';
import { Tooltip } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

interface CopyButtonProps {
  textToCopy: string;
  className?: string;
  tooltipLabel?: string;
  variant?: 'default' | 'success' | 'error';
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  className = '',
  tooltipLabel = 'Copy to clipboard',
  variant = 'default',
}) => {
  const { t } = useTranslation('pleri/chat');
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return 'text-green-700 hover:opacity-80';
      case 'error':
        return 'text-red-700 hover:opacity-80';
      default:
        return 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300';
    }
  };

  return (
    <Tooltip label={tooltipLabel}>
      <button
        onClick={handleCopy}
        className={`flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium transition-colors duration-200 ${getVariantStyles()} ${className}`}
      >
        <svg
          className="h-3.5 w-3.5"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
        {copied ? t('copiedExclamation') : t('copy')}
      </button>
    </Tooltip>
  );
};
